// import { LANG } from '../App/constants'

export const PAYMENT_TRANSFER_STATE_KEY = 'PaymentTransfer'
export const FORM_PAYMENT_TRANSFER = 'formPaymentTransfer'
export const FORM_PAYMENT_TRANSFER_NAME = 'payment_transfer'

export const CONTENT_LOAD = 'Casino/PaymentTransferPage/CONTENT_LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/PaymentTransferPage/CONTENT_LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/PaymentTransferPage/CONTENT_LOAD_ERROR'
